'use server'

import { apiRequest, ApiResponse } from '../request'

export type TikTokConnectionStatus = 'ACTIVE' | 'EXPIRED' | 'REVOKED'

export interface TikTokConnectionSummary {
    pixelId: string | null
    updatedAt: string | null
    connected: boolean
    status: TikTokConnectionStatus | null
    advertiserIds: string[]
    advertiserId: string | null
    advertiserName: string | null
    connectedAt: string | null
    lastError: string | null
    leadSubscribed: boolean
    leadSubscriptionError: string | null
    lastLeadAt: string | null
}

export interface TikTokAdvertiser {
    id: string
    name: string | null
}

export interface TikTokAdvertisersResult {
    ready: boolean
    reason?: string
    advertisers: TikTokAdvertiser[]
}

export async function getTikTokConnection(): Promise<ApiResponse<TikTokConnectionSummary>> {
    return apiRequest<TikTokConnectionSummary>('marketing/tiktok-ads/connection', {})
}

/** Vazio apaga o Pixel: a loja para de carregá-lo. */
export async function updateTikTokPixel(pixelId: string | null): Promise<ApiResponse<TikTokConnectionSummary>> {
    return apiRequest<TikTokConnectionSummary>('marketing/tiktok-ads/pixel', { data: { pixelId } }, 'put')
}

/** URL de autorização do TikTok for Business (o front faz window.location.href). */
export async function getTikTokOAuthUrl(): Promise<ApiResponse<{ url: string }>> {
    return apiRequest<{ url: string }>('marketing/tiktok-ads/oauth/url', {})
}

export async function getTikTokAdvertisers(): Promise<ApiResponse<TikTokAdvertisersResult>> {
    return apiRequest<TikTokAdvertisersResult>('marketing/tiktok-ads/connection/advertisers', {})
}

export async function selectTikTokAdvertiser(advertiserId: string): Promise<ApiResponse<TikTokConnectionSummary>> {
    return apiRequest<TikTokConnectionSummary>('marketing/tiktok-ads/connection', { data: { advertiserId } }, 'patch')
}

export async function resubscribeTikTokLeads(): Promise<ApiResponse<TikTokConnectionSummary>> {
    return apiRequest<TikTokConnectionSummary>('marketing/tiktok-ads/lead-form/subscribe', {}, 'post')
}

export async function disconnectTikTok(): Promise<ApiResponse<TikTokConnectionSummary>> {
    return apiRequest<TikTokConnectionSummary>('marketing/tiktok-ads/connection', {}, 'delete')
}
